import buildUrl from 'build-url';
import { myStorage } from './myStorage';
import _ from 'lodash';

const apiUrl = process.env.REACT_APP_API_URL;


let isIncognitoMode = false
  
try {
  isIncognitoMode = window.localStorage ? true : false;
} catch (e) { 
  console.log("Initializing temporary storage as localStorage is not available");
}

export default class AuthService {

  static isAuthenticated() {
    return !isIncognitoMode ? myStorage.data.token != null : window.localStorage.token != null
  }

  static getAccessToken() {
    return !isIncognitoMode ? myStorage.data.token : window.localStorage.token;
  }

  static getRefreshToken() {

    if (!isIncognitoMode) {
      return myStorage.data.refresh_token;
    }
    else {
      return window.localStorage.refresh_token;
    }
  }

  static saveToken(token, refreshToken) {
    if (!isIncognitoMode) {
      myStorage.setItem('token', token);
      myStorage.setItem('refresh_token', refreshToken);
      return;
    }

    window.localStorage.setItem('token', token);
    window.localStorage.setItem('refresh_token', refreshToken);
  }

  static clearAccessToken() {
    if (!isIncognitoMode) {
      myStorage.removeItem('token');
      myStorage.removeItem('refresh_token');
    }
    else {
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('refresh_token');
    }
  }

  static clearRefreshToken() {
    if (!isIncognitoMode) {
      myStorage.removeItem('refresh_token');
    }
    else {
      window.localStorage.removeItem('refresh_token');
    }
  }

  static getURL(relativeURL, queryParams) {
    if(relativeURL){
      var params = queryParams || {};

      params = {
        ...params,
        access_token: this.getAccessToken()
      };
      
      return buildUrl(apiUrl, {
        path: relativeURL,
        queryParams: params
      });
    }
    return null;
  }

  static saveIntegrationSharedUrlId(integrationSharedUrlId) {
    if (!isIncognitoMode) {
      myStorage.setItem('integration_shared_url_id', integrationSharedUrlId);
    }
    else {
      window.localStorage.setItem('integration_shared_url_id', integrationSharedUrlId);
    }
  }

  static clearIntegrationSharedUrlId() {
    if (!isIncognitoMode) {
      myStorage.removeItem('integration_shared_url_id');
    }
    else {
      window.localStorage.removeItem('integration_shared_url_id');
    }
  }

  static saveIntegrationType(type) {
    if (!isIncognitoMode) {
      myStorage.setItem('integration_type', type);
    }
    else {
      window.localStorage.setItem('integration_type', type);
    }
  }

  static getIntegrationType() {
    if (!isIncognitoMode) {
      return myStorage.data.integration_type
    }
    else {
      return window.localStorage.integration_type;
    }
  }

  static saveActiveTab(tab) {
    if (!isIncognitoMode) {
      myStorage.setItem('active_tab', tab);
    }
    else {
      window.localStorage.setItem('active_tab', tab);
    }
  }

  static getActiveTab() {
    if (!isIncognitoMode) {
      return myStorage.data.active_tab
    }
    else {
      return window.localStorage.active_tab;
    }
  }

  static saveGmailIntegrationStatus(status) {
    if (!isIncognitoMode) {
      myStorage.setItem('activated_gmail_integration', status);
    }
    else {
      window.localStorage.setItem('activated_gmail_integration', status);
    }
  }

  static isGmailIntegrationActivated() {
    if (!isIncognitoMode) {
      return myStorage.data.activated_gmail_integration;
    }
    else {
      return window.localStorage.activated_gmail_integration;
    }
  }
}